'use client';
import { TypeButton, TypePageCaseStudy } from '@fm-nx/contentful-types';
import Slideshow from '../slideshow/slideshow';
import useSWRImmutable from 'swr/immutable';
import { fetcher } from '@fm-nx/contentful';

export interface SlideshowCaseStudiesProps {
    servicePageId?: string;
    headerText?: string;
    button?: TypeButton<'WITHOUT_UNRESOLVABLE_LINKS'>;
    overline?: string;
    solutionId?: string | undefined;
    technologyId?: string;
    serviceId?: string | undefined;
    industryId?: string | undefined;
    excludeId?: string;
}

export function SlideshowCaseStudies(props: SlideshowCaseStudiesProps) {
    const {
        headerText = 'Here are some other case studies you might like.',
        overline = 'Our Work',
        button,
        solutionId,
        technologyId,
        serviceId,
        industryId,
        excludeId,
    } = props;

    const searchParams = new URLSearchParams(`limit=6`);
    if (solutionId) searchParams.append('solutionId', solutionId);
    if (technologyId) searchParams.append('technologyId', technologyId);
    if (serviceId) searchParams.append('serviceId', serviceId);
    if (industryId) searchParams.append('industryId', industryId);
    if (excludeId) searchParams.append('excludeId', excludeId);
    const url = `/api/case-studies?${searchParams.toString()}`;

    // TODO: remove current case study
    const { data } = useSWRImmutable<TypePageCaseStudy<'WITHOUT_UNRESOLVABLE_LINKS'>[]>(url, fetcher);

    return (
        <Slideshow
            overline={overline}
            headerText={headerText}
            button={
                button
                    ? button
                    : ({
                          fields: {
                              buttonText: `Explore all Case Studies`,
                              linkPath: `/case-studies`,
                          },
                      } as TypeButton<'WITHOUT_UNRESOLVABLE_LINKS'>)
            }
            pages={data}
        />
    );
}

export default SlideshowCaseStudies;
